import { booleanAttribute, ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectDataMM13MainElement } from '../../cr13/state/cr13.selectors';
import { OverviewSection } from './models/OverviewSection';
import { NavigationService } from 'src/app/shared/services/navigation/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { AppFeature } from 'src/app/core/app-feature/app-feature';

@Component({
    selector: 'overview-table',
    templateUrl: './overview-table.component.html',
    styleUrl: './overview-table.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OverviewTableComponent {
    @Input()
    data: OverviewSection[] | null = [];

    @Input()
    readonly: boolean = false;

    @Input()
    showCR13Hazards: boolean = false;

    @Input()
    allHazards: any[] | null = [];

    @Input()
    isLoadingAnalysis: boolean | null = false;

    @Input()
    appFeatures: AppFeature[] | null = null;

    @Input({ transform: booleanAttribute })
    isTemplateAnalysis: boolean = false;

    @Output()
    showHazardsToggle = new EventEmitter<void>();

    @Output()
    noStressToggleChange = new EventEmitter<{ criterionId: string; value: boolean }>();

    constructor(private readonly store: Store, private readonly navigateService: NavigationService, private readonly route: ActivatedRoute) {}

    onStressToggleChange(criterionId: string, value: boolean) {
        this.noStressToggleChange.emit({ criterionId, value });
    }

    getDataMM13MainElement(id: number) {
        return this.store.select(selectDataMM13MainElement(id));
    }

    getCR13NoStressStatus(): boolean {
        return this.data?.find(section => section.title === 'PAGE.OVERVIEW.ACCIDENTS.LBL')?.items?.find(item => item.id === 'CR13')?.noStress ?? false;
    }

    onShowHazardsToggle() {
        this.showHazardsToggle.emit();
        setTimeout(() => {
            document.querySelector('.overview__section__content__hazards')?.scrollIntoView({ behavior: 'smooth' });
        });
    }

    navigateToCriterion(criterion: number) {
        this.navigateService.navigateToCriterionFromOverview(criterion, this.isTemplateAnalysis, this.appFeatures, this.route.pathFromRoot[2]);
    }

    convertCriterionIdToNumber(title: string): number {
        return Number(title.replace(/^CR/, ''));
    }
}
